module.exports = __webpack_public_path__ + "static/media/logo.5451dc56.png";